/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_AdminInputs */

const es_chat_tool_detail_admin = /** @type {(inputs: Chat_Tool_Detail_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

const en_chat_tool_detail_admin = /** @type {(inputs: Chat_Tool_Detail_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Chat_Tool_Detail_AdminInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_admin = /** @type {((inputs?: Chat_Tool_Detail_AdminInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_AdminInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_admin(inputs)
	return en_chat_tool_detail_admin(inputs)
});
export { chat_tool_detail_admin as "chat.tool_detail.admin" }